// src/config/imgConfig.js

// const imgPrefix = 'http://43.139.4.162';
// 使用相对路径，通过Nginx代理访问图片

// 部署：统一使用 /upload 直链，避免被 /springboot6hv37/ 反代
const isBrowser = typeof window !== 'undefined';
const isPages = isBrowser && /pages\.dev$/.test(window.location.hostname);
const apiBase = (process.env.REACT_APP_API_BASE_URL || (isPages ? 'https://api-do.whitelotus.work/springboot6hv37' : '/springboot6hv37')).replace(/\/$/, '');
// 图片前缀：不包含 /upload，使用时再拼接
// const imgPrefix = apiBase.replace(/\/springboot6hv37$/, '')

const imgPrefix = "https://api-do.whitelotus.work"

export default imgPrefix;
